module.exports = __webpack_public_path__ + "img/artboard6.6e550226.png";